module.exports = __webpack_public_path__ + "greene-grape.76cf3c54.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/preview/greene-grape.jpg
// module id = 676
// module chunks = 0